export default __webpack_public_path__ + "static/media/Shell.2e2c9edc.jpg";